import React, { Fragment, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { Store } from 'react-notifications-component';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { generarConstanciaFC37, actualizarConstanciaFC37 } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { ObtenerInformacionCliente } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../../../../../redux/AppDucks';

const styleForm = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    'overflowY': 'scroll',
};

const styleModalConfirmacion = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
    p: 4, fontSize: '20px', textAlign: 'center', 'overflowY': 'scroll',
};

function GenerarCertificadoFC37Component(props) {
    const informacionCliente = useSelector(store => store.SolicitudesFC01_OC.informacionCliente)

    const dispatch = useDispatch()
    const [valuesForm, setValuesForm] = React.useState();
    const [openModal, setOpenModal] = React.useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    }
    const modalFormulario = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleForm}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}> Constancia NOM </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <div className='container'>
                                <Formik
                                    initialValues={{ numeroconstancia: '' }}
                                    enableReinitialize={true}
                                    validate={(values) => {
                                        const errors = {}
                                        if (values.numeroconstancia == '') {
                                            errors.numeroconstancia = 'Agregar el número de constancia';
                                        }
                                        return errors;
                                    }}
                                    onSubmit={(values) => { handleOpenConfirmar(values) }}
                                >
                                    <Form>
                                        <div className='form-row'>
                                            <div className="form-group col">
                                                <label for="numeroconstancia" className="row-sm-2 row-form-label">No. de Constancia: </label>
                                                <div className="col">
                                                    <Field type="text" className="form-control" id="numeroconstancia" name="numeroconstancia" />
                                                    <ErrorMessage name="numeroconstancia" component="div" style={{ color: 'red', fontSize: '10pt' }} />
                                                </div>
                                            </div>
                                        </div>
                                        <br></br>
                                        <div className='text-center'>
                                            <div className="col">
                                                <button className='btn btn-success' type='submit'>GUARDAR</button>
                                            </div>
                                        </div>
                                    </Form>
                                </Formik>
                            </div>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    const [modalConfirmar, setModalConfirmar] = React.useState(false);
    const handleOpenConfirmar = (values) => {
        setModalConfirmar(true);
        setValuesForm(values)
    }
    const handleCloseConfirmar = () => {
        setModalConfirmar(false);
    }
    const ModalConfirmar = () => {
        return (
            <Modal
                open={modalConfirmar}
                onClose={handleCloseConfirmar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModalConfirmacion} >
                    <h3>Generar Certificado</h3>
                    Estás seguro de generar esta constancia NOM? <br></br>
                    <button onClick={() => generarConstanciaCumplimiento()} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>

            </Modal>
        )
    }


    const generarConstanciaCumplimiento = async () => {
        await dispatch(actualizarLoadingApp_true())

        const data = props?.data
        let numConstancia = valuesForm.numeroconstancia

        let filtrodomicilio = data?.login?.cliente?.[0]?.domiciliofiscalcliente?.filter(domicilio => domicilio.isbaja == false && domicilio.domicilioprincipal == true)


        let cadenaDomicilio = ''
        const arrayDomicilio = []
        if (filtrodomicilio?.[0]?.calle === 'Otro') arrayDomicilio.push(filtrodomicilio?.[0]?.otracalle)
        else arrayDomicilio.push(filtrodomicilio?.[0]?.calle)
        if (filtrodomicilio?.[0]?.numerointerior != null && filtrodomicilio?.[0]?.numerointerior != '') arrayDomicilio.push(filtrodomicilio?.[0]?.numerointerior)
        else arrayDomicilio.push('S/N')
        if (filtrodomicilio?.[0]?.numeroexterior != null && filtrodomicilio?.[0]?.numeroexterior != '') arrayDomicilio.push(filtrodomicilio?.[0]?.numeroexterior)
        else arrayDomicilio.push('S/N')

        if (filtrodomicilio?.[0]?.colonia != null && filtrodomicilio?.[0]?.colonia != '') arrayDomicilio.push(filtrodomicilio?.[0]?.colonia)
        if (filtrodomicilio?.[0]?.localidad != null && filtrodomicilio?.[0]?.localidad != '') arrayDomicilio.push(filtrodomicilio?.[0]?.localidad)
        if (filtrodomicilio?.[0]?.municipioalcaldia != null && filtrodomicilio?.[0]?.municipioalcaldia != '') arrayDomicilio.push(filtrodomicilio?.[0]?.municipioalcaldia)
        if (filtrodomicilio?.[0]?.estado != null && filtrodomicilio?.[0]?.estado != '') arrayDomicilio.push(filtrodomicilio?.[0]?.estado)
        if (filtrodomicilio?.[0]?.codigopostal != null && filtrodomicilio?.[0]?.codigopostal != '') arrayDomicilio.push(filtrodomicilio?.[0]?.codigopostal)
        for (const i in arrayDomicilio) {
            if (Number(i) === 0) {
                cadenaDomicilio += arrayDomicilio[i]
            } else if (Number(i) + Number(1) === arrayDomicilio.length) {
                cadenaDomicilio += ', ' + arrayDomicilio[i]
            } else {
                cadenaDomicilio += ', ' + arrayDomicilio[i]
            }
        }





        if (informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc37?.length == 0) {

            let datos = {
                nombrerazonsocial: data?.login?.cliente?.[0]?.nombrerazonsocial,
                folioui: data.folioui, domicilio: cadenaDomicilio, rfc: data?.login?.cliente?.[0]?.rfc,
                idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
                numeroConstancia: numConstancia,
            }
            await dispatch(generarConstanciaFC37(datos))
        } else {
            let datos = {
                nombrerazonsocial: data?.login?.cliente?.[0]?.nombrerazonsocial,
                folioui: data.folioui, domicilio: cadenaDomicilio, rfc: data?.login?.cliente?.[0]?.rfc,
                idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
                idsolicitudesocfc37: informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc37?.[0]?.idsolicitudesocfc37,
                numeroConstancia: numConstancia,
            }
            await dispatch(actualizarConstanciaFC37(datos))
        }
        setModalConfirmar(false);
        setOpenModal(false)
        await dispatch(ObtenerInformacionCliente(informacionCliente?.idsolicitudesuifc01))
        await dispatch(actualizarLoadingApp_false())
    }
    return (
        <Fragment>
            <Tooltip title="Nuevo archivo"><IconButton size="large" onClick={() => setOpenModal(true)} > <NoteAddIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
            {modalFormulario()}
            {ModalConfirmar()}
        </Fragment>
    );
};


export default withRouter(GenerarCertificadoFC37Component)